export default __webpack_public_path__ + "static/media/raro-ajuda.6c72cf39.webp";